import Vue from "vue";
import Vuex from "vuex";

import requestModule from "./modules/request";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    requestStatus: "request",
    requestSubmitCount: 0,
    requestSubmitted: false,
    dataError: false,
    errorType: "loading-form-data-error", // Values: 'loading-form-data-error' | 'submitting-form-error'  | 'general-error'
  },
  actions: {
    udpateStatus({ commit }, value) {
      commit("updateRequestStatus", value);
    },
    updateSubmitCount({ commit }, value) {
      commit("updateRequestSubmitCount", value);
    },
  },
  mutations: {
    updateRequestStatus(state, value) {
      state.requestStatus = value;
    },
    updateRequestSubmitCount(state, value) {
      state.requestSubmitCount += value;
    },
    updateRequestSubmitted(state, value) {
      state.requestSubmitted = value;
    },
    updateDataError(state, value) {
      state.dataError = value;
    },
    updateErrorType(state, value) {
      state.errorType = value;
    },
  },
  modules: {
    request: requestModule,
  },
});
